/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ParentInputs */

const en_entity_parent = /** @type {(inputs: Entity_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent`)
};

const de_entity_parent = /** @type {(inputs: Entity_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltern`)
};

/**
* | output |
* | --- |
* | "Parent" |
*
* @param {Entity_ParentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_parent = /** @type {((inputs?: Entity_ParentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ParentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_parent(inputs)
	return de_entity_parent(inputs)
});